import {useMutation, useQueryClient} from '@tanstack/react-query';

import {updateTopic, UpdateTopicParams} from '../api';
import {QUERY__TOPIC, QUERY__TOPICS} from '../queryKeys';

export const useUpdateTopic = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateTopicParams) => updateTopic(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__TOPICS],
      });
      void queryClient.invalidateQueries({
        queryKey: [QUERY__TOPIC],
      });
    },
  });
};
